import { useMemo } from 'react';

import { IconAddPage } from '@picsart/design-system/foundation/icons/IconAddPage';

import addAnalyticsParamsToUrl from 'utils/addAnalyticsParamsToUrl';
import { masonryFirstElement } from '../constants';
import useStyles from './styles';
import { FirstElementProps } from './types';
import normalizeCategoryName from './normalizeCategoryName';

const FirstElement = ({ categoryName }: FirstElementProps) => {
  const classes = useStyles();

  const isSearch = categoryName === 'search';

  // Todo: will be removed after web summit
  const href =
    categoryName === 'logos'
      ? '/logo-generation'
      : addAnalyticsParamsToUrl(masonryFirstElement.url, {
          source: 'templates',
          origin: 'masonry_first_element',
        });

  const displayedCategoryName = useMemo(() => normalizeCategoryName(categoryName), [categoryName]);
  const title = isSearch ? 'Create your own design' : `Create blank ${displayedCategoryName}`;

  return (
    <a
      href={href}
      className={classes.createNew}
      data-pulse-name="Create your own design"
      data-pulse-clickable="true"
      data-testid="first-element"
    >
      <IconAddPage className={classes.icon} />
      <span className={classes.text}>{title}</span>
    </a>
  );
};

export default FirstElement;
